<template>
    <div class="loginPage">
        <v-container class="custom-container bg-register forgot-password">
            <v-row no-gutters>
                <v-col md="12">
                    <div class="top-bar-register">
                        <div class="logo-wrapper">
                            <v-img :width="logoWidth" :height="logoHeight" :src="logoSrc"></v-img>
                        </div>
                        <LanguageMenu></LanguageMenu>
                    </div>
                </v-col>
            </v-row>
            <v-row justify="center" class="mt-10 mb-10" no-gutters>
                <v-col md="7" sm="9" cols="11">
                    <h3 class="justify-center">Create New Account</h3>
                    <div class="wrapper-box">
                        <v-card-text class="text-center account-type-title">Please Choose Your Account Type
                            First</v-card-text>
                        <div class="account-login-links">
                            <v-card :ripple="false" color="transparent" outlined tile
                                :value="registerInfo.owner_type === 1" @click="REGISTER_ACCOUNT_TYPE('Individual')"
                                :class="registerInfo.owner_type === 1
                                        ? 'widgets-card border-active'
                                        : 'widgets-card'
                                    ">
                                <v-btn class="mx-2 mb-3" fab link small elevation="0" color="#1A2A3E">
                                    <v-icon color="greenMain">
                                        mdi-account-outline
                                    </v-icon>
                                </v-btn>
                                <p class="mb-0">Individual</p>
                            </v-card>
                            <v-card :ripple="false" color="transparent" outlined tile
                                :value="registerInfo.owner_type === 2" @click="REGISTER_ACCOUNT_TYPE('Company')" :class="registerInfo.owner_type === 2
                                        ? 'widgets-card border-active'
                                        : 'widgets-card'
                                    ">
                                <v-btn class="mx-2 mb-3" fab link small elevation="0" color="#1A2A3E">
                                    <v-icon color="greenMain">
                                        mdi-home-outline
                                    </v-icon>
                                </v-btn>
                                <p class="mb-0">Company</p>
                            </v-card>
                        </div>
                        <v-btn class="mx-auto text-capitalize btn-account" color="greenMain" tile elevation="0"
                            to="/registration" :disabled="!allConditionsMet">
                            Next
                        </v-btn>

                        <div class="another-link">
                            <p>
                                Already have an account?
                                <router-link to="/">Log in</router-link>
                            </p>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
        <v-container>
            <v-row justify="center" class="mb-5">
                <v-col md="5">
                    <p class="emailLink text-center">
                        <strong>High Risk Investment Warning:</strong> Trading Leveraged
                        Products such as Forex and Derivatives may not be suitable for all
                        investors as they carry a high degree of risk to your capital. Please
                        ensure that you fully understand the risks involved, taking into
                        account your investments objectives and level of experience, before
                        trading, and if necessary, seek independent advice.
                    </p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import LanguageMenu from "@/components/TopBar/LanguageMenu.vue";
import { mapMutations, mapState, mapActions } from "vuex";
import { PUBLIC_LOGIN__ACTIONS } from "@/store/action-types";

export default {
    name: "CreateAccount",
    components: { LanguageMenu },

    computed: {
        ...mapState("authentication", ["registerInfo"]),
        ...mapState("publicinfo", ["info"]),

        allConditionsMet() {
            return this.registerInfo.owner_type;
        },

        logoSrc() {
        return this.info?.logo_url || null;  // Changed from generalInfo to info
        },

        companyName() {
        return this.info?.company_name || "Forex Crm";  // Changed from generalInfo to info
        },

        logoWidth() {
        return this.info?.logo_width || "50px";  // Changed from generalInfo to info
        },
        
        logoHeight() {
        return this.info?.logo_height || "50px";  // Changed from generalInfo to info
        }
    },

    methods: {
        ...mapMutations("authentication", [
            "REGISTER_ACCOUNT_TYPE",
            "REGISTER_FNAME",
            "REGISTER_LNAME",
            "REGISTER_EMAIL",
            "REGISTER_PASSWORD",
            "REGISTER_CONFIRM_PASSWORD",
        ]),

        ...mapActions("publicinfo", [PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]),
    },
    
    async mounted() {
        await this[PUBLIC_LOGIN__ACTIONS.LOGINPAGEINFO]();
        document.title = "Create Account";
    },
};
</script>

<style></style>
